/**
 * Angular imports.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

/**
 * Module imports.
 */
import { ShareModule } from './../common/commons.module';
import { AppHeaderModule } from './../common/header/header.module';
import { CheckBoxSelectModule } from '../check-box-select/check-box-select.module';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { FeedCardModule } from '../web/feed-card/feed-card.module';
import { AnalyticsEventModule } from '../analytics-event/analytics-event.module';
import { ConfirmModalModule } from './../common/confirm-modal/confirm-modal.module';
import { PipesModule } from '../pipes/pipes.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ClinicalResourceCardModule } from '../clinical-resource/clinical-resource-card/clinical-resource-card.module';
import { WebDoctalkCardModule } from '../web-doctalk/web-doctalk-list/web-doctalk-section/web-doctalk-card/web-doctalk-card.module';
import { WebCmeCardModule } from '../web-cme/web-cme-card/web-cme-card.module';

/**
 * Component imports.
 */
import { WebCommunityRoutingModule } from './web-community-routing.module';
import { CommunityListingComponent } from './community-listing/community-listing.component';
import { CommunityComponent } from './community/community.component';
import { CreateCommunityComponent } from './create-community/create-community.component';
import { UpdateCommunityPicModalComponent } from './update-community-pic-modal/update-community-pic-modal.component';
import { CommunityDetailComponent } from './community-detail/community-detail.component';
import { ConnectionCardModule } from './../connection/connection-card/connection-card.module';
import { UserProfilePicModule } from './../common/user-pofile-pic/user-profile-pic.module';
import { ContentCardModule } from './../common/content-card/content-card.module';
import { ProductCommentModule } from './../common/product-comment/product-comment.module';
import { ProductCommentBoxModule } from './../common/product-comment-box/product-comment-box.module';
import { InfoModalModule } from './../common/info-modal/info-modal.module';
import { NgbDropDownModule } from './../common/ngb-drop-down/ngb-drop-down.module';
import { CommunityPostsFilterComponent } from './community-posts-filter/community-posts-filter.component';
import { CommunityPostsFilterFeedComponent } from './community-posts-filter-feed/community-posts-filter-feed.component';
import { CommunityMemberFilterComponent } from './community/community-member-filter/community-member-filter.component';
import { CommunityMemberFilterConnectionsComponent } from './community/community-member-filter-connections/community-member-filter-connections.component';
import { PublicCommunityCardComponent } from './public-community-card/public-community-card.component';
import { PublicCommunityCardItemComponent } from './public-community-card-item/public-community-card-item.component';
import { CommunityListingPastComponent } from './community-listing-past/community-listing-past.component';
import { CommunityJoinRequestsComponent } from './community-join-requests/community-join-requests.component';
import { SingleCommunityCardComponent } from './single-community-card/single-community-card.component';
import { WebinarCardModule } from '../webinar/webinar-list/webinar-section/webinar-card/webinar-card.module';
import { CommunityMemberListComponent } from './community-member-list/community-member-list.component';
import { CommunityMemberListingComponent } from './community-member-listing/community-member-listing.component';
import { WebEventsCardModule } from '../web-events/web-events-list/web-events-card/web-events-card.module';

import { SurveyCardModule } from '../survey/survey-card/survey-card.module';
@NgModule({
  declarations: [
    CommunityListingComponent,
    CommunityComponent,
    CreateCommunityComponent,
    UpdateCommunityPicModalComponent,
    CommunityDetailComponent,
    CommunityPostsFilterComponent,
    CommunityPostsFilterFeedComponent,
    CommunityMemberFilterComponent,
    CommunityMemberFilterConnectionsComponent,
    PublicCommunityCardComponent,
    PublicCommunityCardItemComponent,
    CommunityListingPastComponent,
    CommunityMemberFilterConnectionsComponent,
    CommunityJoinRequestsComponent,
    SingleCommunityCardComponent,
    CommunityMemberListComponent,
    CommunityMemberListingComponent
  ],
  imports: [
    CommonModule,
    WebCommunityRoutingModule,
    AppHeaderModule,
    ShareModule,
    ReactiveFormsModule,
    CheckBoxSelectModule,
    ConnectionCardModule,
    UserProfilePicModule,
    ContentCardModule,
    ProductCommentModule,
    ProductCommentBoxModule,
    InfoModalModule,
    NgbDropDownModule,
    FeedCardModule,
    CarouselModule,
    AnalyticsEventModule,
    AnalyticsEventModule,
    ConfirmModalModule,
    PipesModule,
    WebinarCardModule,
    InfiniteScrollModule,
    ClinicalResourceCardModule,
    WebDoctalkCardModule,
    WebEventsCardModule,
    SurveyCardModule,
    WebCmeCardModule
  ],
  exports: [
    PublicCommunityCardComponent,
    PublicCommunityCardItemComponent,
    SingleCommunityCardComponent
  ]
})
export class WebCommunityModule { }
